import { render, staticRenderFns } from "./ModalProductFeeds.vue?vue&type=template&id=448549f6&scoped=true"
import script from "./ModalProductFeeds.vue?vue&type=script&lang=js"
export * from "./ModalProductFeeds.vue?vue&type=script&lang=js"
import style0 from "./ModalProductFeeds.vue?vue&type=style&index=0&id=448549f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448549f6",
  null
  
)

export default component.exports